// Bulk scan: the count pill and the list, duplicate, discard and resume sheets.
import BulkList, { BulkPill, DiscardSheet, DuplicateSheet, ResumeSheet } from "../BulkList";
import { mark, span } from "../../lib/stepLog";
import { removeItem } from "../../lib/bulkSession";

export function BulkPillSlot({ blView, bulk, bulkLast, bulkPill, checking, deciding, isBulk, photoUi, queue, queueRef, scanUi, setBlView }) {
  return (
    <>
      {isBulk && bulkPill.tone !== "none" && (scanUi || checking || photoUi) && !deciding && !blView ? (
        <BulkPill pill={bulkPill} picture={bulkLast?.pictureUrl} onOpen={() => {
          mark("list_open", { items: bulk.items.length, pending: queue.pending });
          setBlView("list");
        }} onRetry={() => queueRef.current.retry()} />
      ) : null}
    </>
  );
}

export function BulkSheets({ addMore, blConfirm, blView, bulk, bulkEdit, closeBulk, discardAsk, discardGo, dup, dupGoRef, finishEnd, finishing, isBulk, leaveQuick, leaveScan, queue, queueRef, quickMode, resume, setBlConfirm, setBlView, setDiscardAsk, setDup, setFinishing, setResume, shots }) {
  return (
    <>
      {isBulk && blView ? (
        <BulkList
          session={bulk}
          view={blView}
          finishing={finishing}
          confirming={blConfirm}
          onClose={closeBulk}
          onOpen={(key) => setBlView(key)}
          onBack={() => {
            setBlConfirm(false);
            setBlView("list");
          }}
          onRetry={() => queueRef.current.retry()}
          onFinish={() => {
            finishEnd.current = span("finish");
            mark("finish_tap", { pending: queue.pending });
            setFinishing(true);
          }}
          onAddMore={addMore}
          onAskRemove={() => setBlConfirm(true)}
          onCancelRemove={() => setBlConfirm(false)}
          onRemove={(key) => {
            bulkEdit((s) => removeItem(s, key));
            setBlConfirm(false);
            setBlView("list");
          }}
        />
      ) : null}
{dup && isBulk ? (
        <DuplicateSheet
          dup={dup}
          onAdd={(item) => {
            setDup(null);
            dupGoRef.current = null;
            addMore(item);
          }}
          onDifferent={() => {
            const go = dupGoRef.current;
            dupGoRef.current = null;
            setDup(null);
            go?.();
          }}
        />
      ) : null}
{discardAsk && shots.length > 0 ? (
        <DiscardSheet
          title={discardAsk === "quick" ? "Discard these photos?" : "Discard this item?"}
          sub={
            (discardAsk === "quick" ? "Your " : "Its ") +
            shots.length + (shots.length === 1 ? " new photo" : " new photos") +
            " won\u2019t be saved." + (discardAsk === "quick" ? "" : " Items already in this scan stay.")
          }
          thumbs={shots.map((s) => s.previewUrl || s.url)}
          onDiscard={discardGo}
          onKeep={() => setDiscardAsk(null)}
          onLeave={discardAsk === "quick" && quickMode ? leaveQuick : null}
        />
      ) : null}
{resume && isBulk ? (
        <ResumeSheet
          session={bulk}
          onFinish={() => {
            setResume(false);
            leaveScan();
          }}
          onContinue={() => setResume(false)}
        />
      ) : null}
    </>
  );
}
